import { useQuery } from "@tanstack/react-query";
import { fetchVersionInfo } from "@/api/infoApi.ts";

export interface VersionInfo {
    version: string;
    description: string;
    changelog: string;
    releaseDate: string;
}

export const useVersionInfoQuery = () => {
    return useQuery<VersionInfo>({
        queryKey: ["versionInfo"],
        queryFn: fetchVersionInfo,
        staleTime: 1000 * 60 * 30,
    });
};
